import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import React from "react";
import {ValidateStatus} from "../login/signup/hooks/useSignupValidator";
import {useTranslation} from "react-i18next";

interface Args{
    inquiry: string;
    setInquiry: (_:string) => void;
    isInquiryValidate: ValidateStatus;
    setIsInquiryValidate: (_: ValidateStatus) => void;
}
export function ReservationInquiry({inquiry, setInquiry, isInquiryValidate, setIsInquiryValidate}:Args) {
    /**
     * 사전문의 내용 작성 ~ 영역
     */
    const { t } = useTranslation("consultant");
    const handleInquiryChange = (event: any) => {
        setInquiry(event.target.value);
        setIsInquiryValidate(ValidateStatus.NONE)
    };
    return (
        <div className={style.innerTextContainer}>
            <div className={style.infoContainer}>
                <span className={style.infoTitleText}> {t('detail.modal.preQuestion.title')}</span>
                <span className={style.innerTextDesc}>
                {t('detail.modal.preQuestion.desc1')} <br/>
                {t('detail.modal.preQuestion.desc2')}
                <br/>
              </span>
                <div className={style.textareaInputContainer}>
                <textarea
                    placeholder={t('detail.modal.preQuestion.placeholder')}
                    className={style.textareaInput}
                    value={inquiry}
                    onChange={handleInquiryChange}
                />
                    {isInquiryValidate !== ValidateStatus.NONE &&(
                        <span className={style.warning}>문의는 2글자 이상 1000자 이하로 작성해주세요.</span>
                    )}
                </div>
            </div>
        </div>

    )
}